<canvas
    #canvas
    (touchstart)="startDrawing($event)"
    (touchmove)="moved($event)"
    width="700"
    height="200">
</canvas>
<button (click)="savePad()">Save</button>
<button class="btn btn-warning" (click)="undoSign()">Undo</button>
<button (click)="clearPad()">Clear</button>
<div>
    <span style="font-family: monospace;">Write the signature and click on Save</span>
    <div *ngIf="signatureImg">
        <img class='signature' src='{{ signatureImg }}' />
    </div>
</div>
